import React, { useContext } from 'react';
import Collapse from '@material-ui/core/Collapse';
import Location from '@solvhealth/types/interfaces/Location';
import Provider from '@solvhealth/types/interfaces/Provider/index';
import { Stack, Text } from '@solvhealth/jigsaw-v1';
import Booking from '@solvhealth/types/interfaces/Booking';
import StarSelector from '../../SolvPatternLibrary/StarSelector';
import { PRIMARY_RATING } from './PrimaryRatingSelector';
import {
  BEDSIDE_MANNER,
  FACILITY_CLEANLINESS,
  QUALITY_OF_CARE,
  STAFF_FRIENDLINESS,
  WAIT_TIME,
} from '../constants';
import { isTelemedBooking } from '~/core/util/booking';
import { ReviewContext } from '~/routes/addReview/context';
import { isTelemedLocation } from '~/core/util/location';

const SECONDARY_RATINGS = [
  WAIT_TIME,
  QUALITY_OF_CARE,
  BEDSIDE_MANNER,
  STAFF_FRIENDLINESS,
  FACILITY_CLEANLINESS,
];

const TELEMED_SECONDARY_RATINGS = SECONDARY_RATINGS.slice(0, SECONDARY_RATINGS.length - 1);

const getDefaultRatingsQuestions = (booking?: Booking, location?: Location) => {
  if (location) {
    return isTelemedBooking(booking) || (!booking && isTelemedLocation(location))
      ? TELEMED_SECONDARY_RATINGS
      : SECONDARY_RATINGS;
  }
  return SECONDARY_RATINGS;
};

type Props = {
  leaveAReview?: any;
  onChange?: Function;
  location?: Location;
  ratingQuestions?: string[];
  provider?: Provider;
};

const SecondaryStarSelectors = (props: Props) => {
  const { leaveAReview, onChange, location } = props;

  /**
   * If used in an /add-review context the ReviewContext will exist and have a booking that you can check if it's telemed
   * if used in the adding a review on the CDP context there will be no booking to refer to
   */
  const context = useContext(ReviewContext);
  let booking;
  if (context) {
    booking = context.booking;
  }
  const { ratingQuestions = getDefaultRatingsQuestions(booking, location) } = props;

  const renderDimensions = (ratingQuestions: any, leaveAReview: any, onChange: any) =>
    ratingQuestions.map((genre: any) => (
      <Stack
        alignItems="center"
        justifyContent="space-between"
        key={genre}
        maxWidth={475}
        mx="auto"
        row
        width="100%"
      >
        <Text flex="1" textAlign="left" variant="subtitle2">
          {genre}
        </Text>

        <StarSelector
          onChange={(value: any) => onChange({ value, genre })}
          rating={leaveAReview[genre]}
          starWidth={29}
        />
      </Stack>
    ));

  return (
    <Collapse in={!!leaveAReview[PRIMARY_RATING]} timeout="auto">
      <Stack space={3}>
        <Text variant="subtitle">How would you rate the following?</Text>
        {renderDimensions(ratingQuestions, leaveAReview, onChange)}
      </Stack>
    </Collapse>
  );
};

export default SecondaryStarSelectors;
